import { Icon, InlineIcon } from '@iconify/react';
import { OtherPlatformSvg } from '@/widgets/components/other-platform-svg';
import AirbnbLinkIcon from '@/../img/airbnblink.svg';
import BookingLinkIcon from '@/../img/bookinglink.svg';
import FlipKeyLinkIcon from '@/../img/flipkeylink.svg';
import HomeawayLinkIcon from '@/../img/homeawaylink.svg';
import VrboLinkIcon from '@/../img/vrbolink.svg';
import styled from 'styled-components';

// TODO: Let's give up on this.. let's just create a generic icon that accepts a size in props :(
// ...bc I need an icon named IconEvenTinier (8px by 8px)

export const IconGeneric = styled(Icon)`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  transition: transform 0.3s linear;
`;

export const IconSm = styled(Icon)`
  width: 20px;
  height: 20px;
`;

export const IconTiny = styled(InlineIcon)`
  width: 14px;
  height: 14px;
`;

export const IconVeryTiny = styled(InlineIcon)`
  width: 12px;
  height: 12px;
`;

export const IconSuperTiny = styled(InlineIcon)`
  width: 10px;
  height: 10px;
`;

export const linkIconByPlatform = {
  airbnb: AirbnbLinkIcon,
  vrbo: VrboLinkIcon,
  homeaway: HomeawayLinkIcon,
  booking: BookingLinkIcon,
  flipkey: FlipKeyLinkIcon,
  other: OtherPlatformSvg,
};
